import React, { useState, useEffect  }  from "react";
import { useNavigate } from "react-router-dom"; // For navigation
import "./AllProjects.css"; // Create a CSS file for styling
import { getAllProjects } from './Api'; // Import the API function

const AllProjects = () => {
  const navigate = useNavigate(); // Hook for programmatic navigation
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        console.log("Fetching projects...");
        const Selectedprojects = await getAllProjects();
        console.log("API Response:", Selectedprojects.data);
        if(Array.isArray(Selectedprojects.data)){
          setProjects([...Selectedprojects.data]);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };
    fetchProjects();
  }, []);


  const handleProjectClick = (id) => {
    // Navigate to the single project page
    navigate(`/projects/${id}`);
  };

  return (
    <section className="all-projects">
      <h2 className="allprojects-section-title">Projects</h2>
      <div className="allprojects-grid">
        {projects.map((project) => (
          <div className="allprojects-card" key={project.id} 
          onClick={() => handleProjectClick(project.id)}
          >
          <img src={project.cover_photo} alt={project.name} className="allprojects-image" />
          <div className="allprojects-details">
            <h3 className="allprojects-name">{project.name}</h3>
            <div className="tags1" >
              {project.tags && Array.isArray(project.tags) && project.tags.map(tag => (
            <p key={tag.id} className="allprojects-tags">{tag.name}</p>
          ))} </div>
          </div>
        </div>        
        ))}
      </div>
    </section>
  );
};

export default AllProjects;
